module.exports = __webpack_public_path__ + "img/img2.00c9978d.jpg";